import { useMemo } from 'react'

import {
  useDirectoryAccounts,
  useLoadingStatements,
  useStatements,
} from '@/modules/projects'
import { isStatementNotDuplicated } from '@/modules/projects/status/statement'
import { statementViews } from './assignment'
import { splitFromProject } from './fromProject'

// Each step keeps its identity until its input changes, because the strip re-measures on a new one.
export const useProjectSplit = () => {
  const uploads = useStatements()
  // A duplicated upload is hidden on every other screen, so it is not split or counted here either.
  const files = useMemo(
    () => uploads.filter(isStatementNotDuplicated),
    [uploads],
  )
  const directory = useDirectoryAccounts()
  // A refetch keeps whatever is already on screen: only an empty screen is worth a placeholder.
  const filesArriving = useLoadingStatements() && uploads.length === 0
  const split = useMemo(
    () => splitFromProject(files, directory),
    [files, directory],
  )
  const views = useMemo(
    () => statementViews(split.arrangement),
    [split.arrangement],
  )
  return { files, directory, filesArriving, split, views }
}
